import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import BiLink from '../../biLogger/Components/BiLink';
import { BiEventType } from '../../biLogger/constants';
import { useAvatarSrc } from '../../utils/hooks/useAvatarSrc';
import AvatarImage from '../../User/AvatarImage';
import { useFlag } from '../../redux/flags/hooks/useFlag';
import s from './ChatThumbnail.scss';
var ChatThumbnail = React.memo(function (_a) {
    var src = _a.src, avatarClassName = _a.avatarClassName, className = _a.className, indicator = _a.indicator, username = _a.username, _b = _a.isProfileLink, isProfileLink = _b === void 0 ? false : _b;
    var defaultThumbnailSrc = useAvatarSrc();
    var newUserAvatar = useFlag('new_user_avatar');
    var mergedClassNames = classnames(s['root'], className);
    var content = (React.createElement(React.Fragment, null,
        newUserAvatar ? (React.createElement(AvatarImage, { alt: "", src: src, className: classnames(s['avatar'], avatarClassName) })) : (React.createElement("img", { alt: "", src: src !== null && src !== void 0 ? src : defaultThumbnailSrc, className: classnames(s['avatar'], avatarClassName) })),
        indicator));
    return isProfileLink && username ? (React.createElement(BiLink, { className: mergedClassNames, href: Url.userLink(username), biData: {
            evid: BiEventType.DEFAULT,
        } }, content)) : (React.createElement("div", { className: mergedClassNames }, content));
});
ChatThumbnail.displayName = 'ChatThumbnail';
export default ChatThumbnail;
//# sourceMappingURL=ChatThumbnail.js.map